import { useTranslation } from 'react-i18next';
import type { ConsultationService } from '../../../types';

interface ConsultationServiceCardProps {
  service: ConsultationService;
  delayIndex: number;
  onBook: (service: ConsultationService) => void;
}

function ConsultationServiceCard({
  service,
  delayIndex,
  onBook,
}: ConsultationServiceCardProps) {
  const { t } = useTranslation();

  return (
    <article className={`consult-card reveal reveal-delay-${Math.min(delayIndex, 5)}`}>
      <div className="consult-card-image">
        <img src={service.image} alt={service.title} />
      </div>
      <div className="consult-card-body">
        <h3 className="consult-card-title">{service.title}</h3>
        <p className="consult-card-summary">{service.summary}</p>

        <div className="consult-card-meta">
          <span className="consult-badge">
            <svg className="consult-badge-icon" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
              <path d="M15 8v8H5V8h10m1-2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4V7a1 1 0 0 0-1-1z" />
            </svg>
            {t('consultation.available')}
          </span>

          <span className="consult-duration">
            {t('booking.durationValue', { minutes: service.durationMinutes })}
          </span>
        </div>

        <button
          type="button"
          className="consult-book-btn"
          onClick={() => onBook(service)}
          aria-label={t('booking.openFormFor', { service: service.title })}
        >
          {t('consultation.book')}
        </button>
      </div>
    </article>
  );
}

export default ConsultationServiceCard;
